<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      userT: this.$store.state.authfack.user,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalArticulos: 0,
        total: "",
        state: true,
        id: 0,
        totalPendiente:0,
        totalPagado:0
      },
      no_venta:0,
      estadoCredito:null,
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
          .get(
              process.env.VUE_APP_URL +
              "ventas/view_venta?id=" +
              this.$route.params.id,
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            console.log("response", response.data.orden);
            this.no_venta = response.data.orden.no_ducumento_v;
            this.estadoCredito = response.data.orden.estado_credito_v;
            let no_articulos = 0;
            this.formPro.totalPendiente = response.data.orden.saldo_credito_v
            this.formPro.totalPagado = (parseFloat(response.data.orden.total_v) - parseFloat(response.data.orden.saldo_credito_v));

            this.formPro.cliente =
                response.data.orden.cliente_rapido == "" ||response.data.orden.cliente_rapido==null
                    ? response.data.orden.cliente.persona.nombre_persona
                    : response.data.orden.cliente_rapido;

            this.formPro.total = response.data.orden.total_v;
            this.formPro.no_orden = response.data.orden.no_ducumento_v;
            this.formPro.empleado =
                response.data.orden.user.empleado.persona.nombre_persona +
                " " +
                response.data.orden.user.empleado.persona.apellido_persona;

            let detalleProducto = response.data.orden.detalle_ventas;
            let detalleServicio = response.data.orden.detalle_servicio_vs;
            console.log(detalleProducto);
            console.log(detalleServicio);

            if (detalleProducto.length > 0) {
              for (let i = 0; i < detalleProducto.length; i++) {
                no_articulos = no_articulos + detalleProducto[i].cantidad_venta;
                me.detalleorden.push({
                  cantidad: detalleProducto[i].cantidad_venta,
                  descripcion:
                      detalleProducto[i].producto.nombre_producto ,
                  valor_unitario: detalleProducto[i].precio_venta,
                  subtotal: detalleProducto[i].subtotal_venta,
                });
              }
            }

            if (detalleServicio.length > 0) {
              for (let i = 0; i < detalleServicio.length; i++) {
                no_articulos++;
                me.detalleorden.push({
                  cantidad: detalleServicio[i].cantidad_servicios,
                  descripcion:
                      detalleServicio[i].servicio.nombre_servicio ,
                  valor_unitario: detalleServicio[i].precio_servicio,
                  subtotal: detalleServicio[i].subtotal_servicio,
                });
              }
            }

            console.log("a", no_articulos);
            this.formPro.totalArticulos = no_articulos;
          });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones (no se imprimen) -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'ventas' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Ticket -->
    <div class="ticket-wrap">
      <div class="ticket">
        <div class="tk-head">
          <img :src="logoUrl" alt="Logo" class="tk-logo" />
          <div class="tk-store">Repuestos Ariel GT</div>
          <div class="tk-sub">Comapa, Jutiapa</div>
          <div class="tk-sub">Tel 3453 · Claro 345 · Tigo 345</div>
        </div>

        <div class="tk-divider"></div>

        <div class="tk-meta">
          <div class="tk-datetime">{{ showHour(new Date()) }}</div>
          <div v-if="estadoCredito" class="tk-credit">VENTA AL CRÉDITO</div>
        </div>

        <div class="tk-info">
          <div class="tk-row"><span>Cliente</span><b>{{ formPro.cliente }}</b></div>
          <div class="tk-row"><span>Cajero</span><b>{{ formPro.empleado }}</b></div>
          <div class="tk-row"><span>Venta #</span><b>{{ no_venta }}</b></div>
        </div>

        <div class="tk-divider"></div>

        <table class="tk-table">
          <thead>
            <tr>
              <th class="c">Cant.</th>
              <th>Descripción</th>
              <th class="r">Precio</th>
              <th class="r">Importe</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in detalleorden" v-bind:key="idx">
              <td class="c">{{ item.cantidad }}</td>
              <td>{{ item.descripcion }}</td>
              <td class="r">{{ money(item.valor_unitario) }}</td>
              <td class="r">{{ money(item.subtotal) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="tk-divider"></div>

        <div class="tk-row tk-articulos">
          <span>No. de artículos</span><b>{{ formPro.totalArticulos }}</b>
        </div>
        <div class="tk-total">
          <span>TOTAL</span><span>{{ money(formPro.total) }}</span>
        </div>
        <div v-if="estadoCredito" class="tk-saldos">
          <div class="tk-row"><span>Saldo restante</span><b>{{ money(formPro.totalPendiente) }}</b></div>
          <div class="tk-row"><span>Saldo pagado</span><b>{{ money(formPro.totalPagado) }}</b></div>
        </div>

        <div class="tk-divider"></div>

        <p class="tk-nota">
          IMPORTANTE: Apreciable cliente, en repuestos no se aceptan cambios ni
          devoluciones. Para cambios y devoluciones de otros artículos el plazo es de
          3 días hábiles; deberá presentar su factura o comprobante de compra y el
          producto debe encontrarse en las mismas condiciones en que fue entregado.
        </p>

        <div class="tk-thanks">¡Gracias por su compra!</div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.ticket-wrap { display: flex; justify-content: center; }
.ticket {
  width: 320px;
  background: #fff;
  color: #1a1a1a;
  font-family: 'Segoe UI', Arial, sans-serif;
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.35;
}
.tk-head { text-align: center; }
.tk-logo { height: 70px; width: auto; object-fit: contain; margin-bottom: 6px; }
.tk-store { font-size: 18px; font-weight: 800; letter-spacing: .3px; }
.tk-sub { font-size: 12px; color: #444; }
.tk-divider { border-top: 1px dashed #999; margin: 10px 0; }
.tk-meta { text-align: center; }
.tk-datetime { font-size: 12px; color: #333; }
.tk-credit {
  display: inline-block; margin-top: 4px;
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 11px;
  padding: 2px 10px; border-radius: 3px; letter-spacing: .5px;
}
.tk-info { margin-top: 8px; }
.tk-row { display: flex; justify-content: space-between; gap: 8px; }
.tk-row span { color: #555; }
.tk-row b { text-align: right; }
.tk-table { width: 100%; border-collapse: collapse; }
.tk-table thead th {
  font-size: 11px; text-transform: uppercase; border-bottom: 1px solid #333;
  padding: 4px 2px; text-align: left;
}
.tk-table tbody td { padding: 4px 2px; font-size: 12px; vertical-align: top; }
.tk-table .r { text-align: right; }
.tk-table .c { text-align: center; }
.tk-articulos { font-size: 12px; }
.tk-total {
  display: flex; justify-content: space-between; align-items: center;
  font-size: 20px; font-weight: 800; margin-top: 6px; padding: 6px 0;
  border-top: 2px solid #1b2a4e; border-bottom: 2px solid #1b2a4e;
}
.tk-saldos { margin-top: 6px; font-size: 12px; }
.tk-nota { font-size: 10px; color: #555; text-align: justify; }
.tk-thanks { text-align: center; font-weight: 700; margin-top: 8px; }

@media print {
  @page { margin: 0; size: auto; }
  .ticket { width: 100%; padding: 6px; }
  .ticket, .ticket * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
